export default "__VITE_ASSET__b8df67d1__"